/** Canonical kit sizes used for GPU instancing scale — must match AmhsKitTemplateCapture. */
export const AMHS_KIT_TEMPLATE_DIMS = {
  CleanroomWorkcell: { w: 16.0, h: 20.0, d: 13.0 },
  Awp300: { w: 18.0, h: 22.0, d: 14.0 },
  IndustrialVerticalLifter3D: { w: 12.0, h: 32.0, d: 12.0 },
  Stocker3D: { w: 24.0, h: 26.0, d: 16.0 },
  CircleStocker: { w: 22.0, h: 28.0, d: 22.0 },
  JunctionRing: { ringR: 18.0, depth: 3.0, trackW: 4.0, footprint: 36.0 },
  OhtVehicle: { w: 10.0, h: 7.5, d: 5.5 },
} as const;
